<template>
    <v-card
        style="background-color: transparent; width: 100%"
        elevation="0"
        v-if="invoice"
        class="oss-card"
    >
        <v-card-title
            :class="
                !$vuetify.display.mobile
                    ? 'title font-weight-regular justify-space-between'
                    : 'title font-weight-regular pa-1'
            "
            class="d-flex flex-row justify-between"
        >
            <span>{{ stepTitle }}</span>
            <v-avatar
                color="secondary lighten-2"
                class="subheading white--text"
                size="24"
                v-text="stepNumber"
                v-if="!$vuetify.display.mobile"
            />
        </v-card-title>
        <v-window v-model="wizardStep" style="min-height: 27vh">
            <v-window-item :value="0">
                <v-card-text class="pa-2">
                    <v-text-field-filled
                        label="Titre (Optionnel)"
                        outlined
                        autofocus
                        v-model="invoice.title"
                        :readonly="isLocked"
                        data-cy="invoiceWizard-title"
                        density="compact"
                    />
                    <div class="text-end mt-3">
                        <v-btn
                            rounded
                            elevation="0"
                            @click="routeToEdition()"
                            data-cy="invoiceWizard-next"
                            size="small"
                        >
                            Passer directement à l'édition
                        </v-btn>
                    </div>
                </v-card-text>
            </v-window-item>
            <v-window-item :value="1">
                <v-card-text class="px-0 py-3 fill-height d-flex align-center">
                    <v-card
                        class="inside_card"
                        width="100%"
                        elevation="0"
                        @click="dialogEditCompany = true"
                        data-cy="InvoiceWizard-client"
                    >
                        <v-card-title
                            primary-title
                            style="padding-top: 5px; padding-bottom: 5px"
                            class="d-flex flex-row justify-between justify-space-between"
                        >
                            <span>{{ userCompany.name }}</span>
                            <v-btn
                                rounded
                                size="small"
                                elevation="0"
                                data-cy="invoiceWizard-edit-company"
                            >
                                éditer <v-icon class="ml-2" size="small" right>$edit</v-icon>
                            </v-btn>
                        </v-card-title>
                        <v-card-text>
                            <v-row no-gutters>
                                <v-col cols="12" :class="userCompany.siret ? '' : 'text-red'">
                                    Siret : {{ getSiretValue(userCompany.siret) || "manquant" }}
                                </v-col>
                                <v-col
                                    cols="12"
                                    :class="
                                        userCompany.address ||
                                        userCompany.postalCode ||
                                        userCompany.city
                                            ? ''
                                            : 'text-red'
                                    "
                                    class="text--muted"
                                >
                                    Adresse : {{ userCompany.address }}
                                    {{ userCompany.postalCode }} {{ userCompany.city }}
                                    <!-- {{ userCompany.country }} -->
                                </v-col>
                                <v-col cols="12" :class="userCompany.legalForm ? '' : 'text-red'">
                                    {{ $t("settings.legalForm") }} : {{ userCompany.legalForm }}
                                </v-col>
                                <!-- <v-flex xs12 :class="userCompany.taxSystem ? '' : 'text-red'">
                                    Régime TVA : {{ taxSystems[userCompany.taxSystem] }}
                                </v-flex> -->
                                <v-col
                                    cols="12"
                                    :class="userCompany.registrationTown ? '' : 'text-red'"
                                    v-if="displayRegistrationTown"
                                >
                                    Ville d'enregistrement RCS : {{ userCompany.registrationTown }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-card-text>
            </v-window-item>
            <v-window-item :value="2">
                <v-card-text>
                    <v-card
                        v-if="invoice.client && invoice.client.name"
                        class="inside_card"
                        elevation="0"
                    >
                        <v-card-title style="padding-top: 5px; padding-bottom: 5px">
                            <v-row no-gutters>
                                <v-col cols="12" primary-title>
                                    {{ invoice.client ? invoice.client.name : "" }}
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <v-card-text>
                            <v-row no-gutters>
                                <v-col cols="12">
                                    Adresse : {{ invoice.client.address }}
                                    {{ invoice.client.postalCode }} {{ invoice.client.city }}
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-row no-gutters class="py-2 align-self-center">
                        <v-col cols="12" class="d-flex justify-center align-center my-auto">
                            <v-btn
                                dark
                                size="small"
                                elevation="0"
                                rounded
                                @click.stop="setClientStep()"
                                data-cy="invoiceWizard-select-client"
                                >{{
                                    invoice.client && invoice.client.id
                                        ? "Choisir un autre client"
                                        : "Choisir un client"
                                }}<v-icon size="small" class="ml-2" right>$edit</v-icon></v-btn
                            >
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-window-item>
            <v-window-item :value="3">
                <v-card-text>
                    <template v-if="selectVATType">
                        <v-radio-group v-model="invoice.vatType" inline color="primary">
                            <v-radio label="Aucun" value="NO_VAT_TYPE" />
                            <v-radio label="Intracom" value="INTRACOM" />
                            <!-- not vat accountable account (invoice) -->
                            <v-radio label="Export" value="EXPORT" />
                            <v-radio label="Autoliquidation" value="REVERSE_CHARGE" />
                        </v-radio-group>
                    </template>
                    <v-list lines="two">
                        <v-list-item
                            v-for="(income, i) in invoice.lines"
                            :key="i"
                            :class="
                                !$vuetify.display.mobile
                                    ? 'mb-2 py-2 oss-list-item'
                                    : 'mb-2 pa-2 oss-list-item'
                            "
                        >
                            <v-list-item-title>{{ income.title }}</v-list-item-title>
                            <v-list-item-subtitle
                                >{{ "Réf : " + income.reference ? income.reference + " -" : "" }}
                                {{ "HT : " + newCommonFormatCurrency(income.netAmount, undefined) }}
                                ({{ income.vatRate }} %)</v-list-item-subtitle
                            >

                            <template v-slot:append class="my-0">
                                <v-btn-trash @click="deleteLine(i)" />
                            </template>
                        </v-list-item>
                    </v-list>
                    <v-card class="inside_card" elevation="0" py-3 mb-3 v-if="invoice.lines.length">
                        <v-row no-gutters>
                            <v-col cols="6" px-2 class="d-flex justify-end" v-if="isVatSubject">
                                <strong>Total HT</strong>
                            </v-col>
                            <v-col cols="6" px-2 class="d-flex justify-end" v-if="isVatSubject">
                                <strong>{{
                                    newCommonFormatCurrency(netAmountTotal, undefined)
                                }}</strong>
                            </v-col>
                            <v-col cols="6" px-2 class="d-flex justify-end" v-if="isVatSubject">
                                Total TVA
                            </v-col>
                            <v-col cols="6" px-2 class="d-flex justify-end" v-if="isVatSubject">
                                {{ newCommonFormatCurrency(vatAmountTotal, undefined) }}
                            </v-col>
                            <v-col cols="6" px-2 class="d-flex justify-end">
                                <strong>Total {{ isVatSubject ? "TTC" : "" }}</strong>
                            </v-col>
                            <v-col cols="6" px-2 class="d-flex justify-end">
                                <strong>{{
                                    newCommonFormatCurrency(grossAmountTotal, undefined)
                                }}</strong>
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-row no-gutters class="mt-3">
                        <v-col class="d-flex justify-space-between">
                            <v-btn
                                elevation="0"
                                rounded
                                @click="wizardStep = 5"
                                :disabled="!products.length"
                                data-cy="invoiceWizard-addExistingProduct"
                                size="small"
                            >
                                Ajouter un produit enregistré
                            </v-btn>
                            <v-btn
                                elevation="0"
                                dark
                                rounded
                                size="small"
                                @click="wizardStep = 4"
                                data-cy="InvoiceWizard-newProduct"
                            >
                                Ajouter un nouveau produit
                            </v-btn>
                            <!-- <v-btn
                                color="primary"
                                elevation="0"

                                rounded size="small"
                                @click="wizardStep = 14"
                            >
                                Ajouter une remise
                            </v-btn> -->
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-window-item>
            <!-- Create  new product -->
            <v-window-item :value="4">
                <v-card-text class="py-3">
                    <v-card class="inside_card px-2 mb-6" elevation="0">
                        <CreateInvoiceProduct
                            ref="createInvoiceProduct"
                            :vatSubject="isVatSubject"
                            :companyId="companyId"
                            :saveable="true"
                            @product="setExistingProduct($event)"
                            @product-created="addLine($event)"
                        />
                    </v-card>
                    <v-row no-gutters>
                        <v-col cols="6" class="pr-1">
                            <oss-text-field-filled
                                outlined
                                @update:model-value="updateLineAmounts(income)"
                                label="Quantité"
                                :suffix="''"
                                dense
                                data-cy="invoiceWizard-newProduct-quantity"
                                v-model="income.quantity"
                            />
                        </v-col>
                        <v-col cols="6" pl-1>
                            <oss-text-field-filled
                                outlined
                                readonly
                                label="Montant HT"
                                dense
                                v-model="incomeNetAmount"
                                data-cy="InvoiceWizard-montantHT"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-window-item>
            <!-- Select existing product -->
            <v-window-item :value="5">
                <v-card-text>
                    <v-row no-gutters class="pt-3">
                        <v-col cols="12" class="pb-3">
                            <v-text-field-filled
                                outlined
                                v-model.number="income.quantity"
                                type="number"
                                @update:model-value="updateLineAmounts(income)"
                                label="Quantité"
                                data-cy="invoiceWizard-existingProduct-quantity"
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="12">
                            <SelectProduct
                                :companyId="companyId"
                                :invoiceProductType="'PRODUCT'"
                                @product="setExistingProduct"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-window-item>
            <v-window-item :value="6">
                <v-card-text>
                    <v-row no-gutters>
                        <template v-if="gonnaBeRecurrenceInvoice">
                            <v-col cols="12">
                                <v-date-picker-wrapper
                                    v-model="invoiceStartDate"
                                    type="date"
                                    width="100%"
                                    :landscape="!$vuetify.display.mobile"
                                    class="elevation-0"
                                    color="gradient"
                                    scrollable
                                    :allowed-dates="allowedDates"
                                />
                                <!-- <oss-date-picker
                                    v-model="invoice.startDate"
                                    width="100%"
                                /> -->
                            </v-col>
                        </template>
                        <template v-else>
                            <v-col cols="12">
                                <!-- <h3>Date d'émission du document</h3> -->
                                <v-date-picker-wrapper
                                    v-model="invoiceDate"
                                    type="date"
                                    width="100%"
                                    :landscape="!$vuetify.display.mobile"
                                    class="elevation-0"
                                    color="gradient"
                                    :allowed-dates="allowedDates"
                                    data-cy="InvoiceWizard-emission"
                                />
                                <!-- <oss-date-picker
                                    v-model="invoice.date"
                                    width="100%"
                                /> -->
                            </v-col>
                        </template>
                        <v-col cols="12" class="d-flex justify-center" v-if="isInvoice">
                            <v-switch
                                v-model="gonnaBeRecurrenceInvoice"
                                class="ma-2"
                                label="Avec récurrence"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-window-item>
            <v-window-item :value="7">
                <v-card-text>
                    <span class="mb-2">
                        {{
                            this.gonnaBeRecurrenceInvoice
                                ? "Date de la première facture"
                                : "Date d'émission"
                        }}: {{ formatDate(invoice.date) }}
                    </span>
                    <template v-if="gonnaBeRecurrenceInvoice">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-date-picker-wrapper
                                    v-model="invoiceEndDate"
                                    type="date"
                                    width="100%"
                                    :landscape="!$vuetify.display.mobile"
                                    class="elevation-0"
                                    color="primary"
                                    scrollable
                                    :disabled="isInfinitReccurency"
                                    data-cy="InvoiceWizard-echeance"
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-switch
                                    v-model="isInfinitReccurency"
                                    class="ma-2"
                                    label="Sans date de fin"
                                />
                            </v-col>
                        </v-row>
                    </template>
                    <template v-else>
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-date-picker-wrapper
                                    v-model="invoiceDueDate"
                                    width="100%"
                                    :landscape="!$vuetify.display.mobile"
                                    class="elevation-0"
                                    color="gradient"
                                    scrollable
                                    :allowed-dates="allowedDueDate"
                                    data-cy="InvoiceWizard-fin"
                                />
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>
            </v-window-item>
            <v-window-item :value="8">
                <LegalForm
                    :companyId="companyId"
                    @paymentDetails-changed="onInvoicePaymentDetailsChanged($event)"
                    @legalNotices-changed="
                        (data) => {
                            this.invoice.data.legalText = data;
                        }
                    "
                    @paymentMode-changed="onInvoicePaymentModeChanged($event)"
                    v-if="wizardStep === 8"
                />
            </v-window-item>
            <v-window-item :value="9">
                <Logo :companyId="companyId" />
            </v-window-item>
            <v-window-item :value="10">
                <v-card-text class="pa-0">
                    <company-table
                        :showGenericCompany="false"
                        :showConsumerCompany="true"
                        :showCustomerCompanies="true"
                        :showExistingCompanies="false"
                        :company="invoice.client ? invoice.client.name : ''"
                        :siret="invoice.client ? invoice.client.siret : ''"
                        :siren="invoice.client ? invoice.client.siren : ''"
                        :vatNumber="invoice.client ? invoice.client.vatNumber : ''"
                        :parentCompanyId="selectedCompany.id"
                        :wizardMode="true"
                        @select-company="companySelectedWizard"
                    />
                </v-card-text>
            </v-window-item>
            <v-window-item :value="11">
                <v-card-text class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-list-item
                                v-for="recType in reccurencyType"
                                :key="recType.value"
                                @click="
                                    () => {
                                        invoice.periodicity = recType.value;
                                    }
                                "
                                style="background: #fff"
                                class="mt-2"
                            >
                                <v-list-item-title>
                                    {{ recType.text }}
                                </v-list-item-title>

                                <template v-slot:append class="my-0">
                                    <v-btn-icon
                                        color="primary"
                                        :icon="
                                            invoice.periodicity === recType.value
                                                ? '$radio_button_checked'
                                                : '$radio_button_unchecked'
                                        "
                                    >
                                    </v-btn-icon>
                                </template>
                            </v-list-item>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-window-item>
            <v-window-item :value="12">
                <v-card-text class="pa-0">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-text-field-filled
                                outlined
                                v-model.number="dueDateAmount"
                                type="number"
                                label="Nombre"
                                density="compact"
                            />
                        </v-col>
                        <v-col cols="12">
                            <v-list-item
                                v-for="unit in unitsOfTime"
                                :key="unit.value"
                                @click="
                                    () => {
                                        unitOfTime = unit.value;
                                    }
                                "
                                style="background: #fff"
                                class="mt-2"
                            >
                                <template v-slot:append class="my-0">
                                    <v-btn-icon
                                        color="primary"
                                        :icon="
                                            unitOfTime === unit.value
                                                ? '$radio_button_checked'
                                                : '$radio_button_unchecked'
                                        "
                                    >
                                    </v-btn-icon>
                                </template>
                                <v-list-item-title>
                                    {{ unit.text }}
                                </v-list-item-title>
                            </v-list-item>
                        </v-col>
                        <v-col
                            cols="12"
                            class="d-flex justify-center mt-1"
                            style="font-size: 15px"
                            v-if="!isInfinitReccurency"
                        >
                            {{ sumUpReccurency() }}
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-window-item>
            <v-window-item :value="13">
                <v-card-text class="pa-0">
                    <editCompany
                        ref="companyEdition"
                        :in-company="invoice.client"
                        :clientInvoiceMode="true"
                        @updated="updateClientInvoice($event)"
                    />
                </v-card-text>
            </v-window-item>
        </v-window>
        <v-card-actions v-if="showAction">
            <v-btn v-if="wizardStep !== 10" rounded elevation="0" @click="previous()" size="small"
                >Précédent</v-btn
            >
            <v-spacer />
            <template v-if="wizardStep === 4">
                <v-btn
                    rounded
                    elevation="0"
                    :disabled="addIncomeVerification"
                    @click="createProduct()"
                    data-cy="invoiceWizard-create-product"
                    size="small"
                    >Ajouter</v-btn
                >
            </template>
            <template v-else-if="wizardStep === 5">
                <v-btn
                    rounded
                    elevation="0"
                    :disabled="addIncomeVerification"
                    @click="
                        addLine();
                        wizardStep = 3;
                    "
                    data-cy="invoiceWizard-add-product"
                    size="small"
                    >Ajouter</v-btn
                >
            </template>
            <template v-else-if="wizardStep === 9 || (wizardStep === 8 && userCompany.logo)">
                <v-btn
                    rounded
                    elevation="0"
                    @click="saveInvoice()"
                    :loading="isSaving"
                    v-if="!isLocked"
                    data-cy="invoiceWizard-create"
                    size="small"
                    >Enregistrer</v-btn
                >
            </template>
            <template v-else-if="wizardStep === 13">
                <v-btn
                    rounded
                    elevation="0"
                    @click="$refs.companyEdition.upsertCompany()"
                    data-cy="invoiceWizard-upsertCompany"
                    size="small"
                >
                    Suivant
                </v-btn>
            </template>
            <template v-else-if="wizardStep === 10">
                <v-btn
                    rounded
                    elevation="0"
                    :loading="isSaving"
                    @click="wizardStep = 2"
                    :disabled="wizardStep === 2"
                    data-cy="invoiceWizard-cancel"
                    size="small"
                    >Annuler</v-btn
                >
            </template>
            <template v-else-if="wizardStep !== 8 || !userCompany.logo">
                <v-btn
                    rounded
                    elevation="0"
                    :disabled="nextVerification"
                    @click="next()"
                    data-cy="invoiceWizard-next"
                    size="small"
                    >Suivant</v-btn
                >
            </template>
        </v-card-actions>
        <oss-dialog
            v-model="dialogEditCompany"
            :fullscreen="$vuetify.display.mobile"
            :actions="userCompanyActions"
            title="Modifier les informations de votre société"
            width="100vw"
        >
            <editCompany
                ref="editCompany"
                :companyId="userCompany.id"
                :actions="userCompanyActions"
                @updated="closeDialogEditCompany"
                :vatSystemHide="true"
            />
        </oss-dialog>
    </v-card>
</template>

<script lang="ts">
import moment from "moment-timezone";
// import gql from "graphql-tag"
import { Company } from "../../../../types";

import LegalForm from "../configuration/LegalForm.vue";
import Logo from "../configuration/Logo.vue";
import { InvoiceEditionBase } from "./InvoiceEditionBase";

import CreateInvoiceProduct from "./CreateInvoiceProduct.vue";
import SelectProduct from "./SelectInvoiceProduct.vue";

import { isNotSubjectToVAT } from "@/services/vat/vatHelpers.services";
import { getSiretValue } from "../../../src/services/companyServices";
import { DialogAction } from "../../services/dialogAction";

import { Component, Prop, Watch, toNative } from "vue-facing-decorator";

@Component({
    components: {
        Logo,
        LegalForm,
        SelectProduct,
        CreateInvoiceProduct,
    },
    emits: ["back", "validAction"],
})
export class InvoiceWizard extends InvoiceEditionBase {
    @Prop({ default: false }) invoiceTableMode: boolean;
    @Prop({ default: null }) actions: any;

    wizardStep_ = 0;

    isDateChanged = true;

    userCompanyActions = {
        action: new DialogAction(),
    };

    get wizardStep() {
        return this.wizardStep_;
    }

    get showAction() {
        return !this.actions;
    }

    get invoiceDate() {
        return moment(this.invoice.date).toDate();
    }

    set invoiceDate(value) {
        this.invoice.date = moment(value).format();
        // this.isDateChanged = true;
    }

    get invoiceStartDate() {
        return moment(this.invoice.startDate).toDate();
    }

    set invoiceStartDate(value) {
        this.invoice.startDate = moment(value).format();
    }

    get invoiceEndDate() {
        return moment(this.invoice.endDate).toDate();
    }

    set invoiceEndDate(value) {
        this.invoice.endDate = moment(value).format();
    }

    get invoiceDueDate() {
        return moment(this.invoice.dueDate).toDate();
    }

    set invoiceDueDate(value) {
        this.invoice.dueDate = moment(value).format();
    }

    set wizardStep(data) {
        this.wizardStep_ = data;
        // debugger
        // @ts-ignore
        if (data === 9 || (data === 8 && this.userCompany.logo)) {
            this.$emit("validAction", true);
            if (this.actions && this.actions.action) {
                this.actions.action.display = true;
                this.actions.action.disabled = this.nextVerification_;
                this.actions.action.title = "Valider";
                this.actions.action.function = this.next;
            }
        } else {
            if (this.actions && this.actions.action) {
                if (this.wizardStep === 4) {
                    this.actions.action.display = true;
                    this.actions.action.disabled = () => {
                        return this.addIncomeVerification;
                    };
                    this.actions.action.title = "Ajouter";
                    this.actions.action.function = this.createProduct;
                } else if (this.wizardStep === 5) {
                    this.actions.action.display = true;
                    this.actions.action.disabled = () => {
                        return this.addIncomeVerification;
                    };
                    this.actions.action.title = "Ajouter";
                    this.actions.action.function = () => {
                        this.addLine();
                        this.wizardStep = 3;
                    };
                    // @ts-ignore
                } else if (
                    this.wizardStep === 9 ||
                    (this.wizardStep === 8 && (this.userCompany as any)?.logo)
                ) {
                    this.actions.action.display = true;
                    this.actions.action.disabled = false;
                    this.actions.action.title = "Enregistrer";
                    this.actions.action.function = this.saveInvoice;
                } else if (this.wizardStep === 10) {
                    this.actions.action.display = true;
                    this.actions.action.disabled = () => this.wizardStep === 2;
                    this.actions.action.title = "Annuler";
                    this.actions.action.function = () => {
                        this.wizardStep = 2;
                    };
                } else if (this.wizardStep === 13) {
                    this.actions.action.display = true;
                    this.actions.action.disabled = false;
                    this.actions.action.title = "Suivant";
                    // @ts-ignore
                    this.actions.action.function = () => {
                        (this.$refs.companyEdition as any).upsertCompany();
                    };
                    // @ts-ignore
                    // } else if (this.wizardStep === 14) {
                    //     this.actions.action.display = true
                    //     this.actions.action.disabled = () => { return !this.isValidDiscount }
                    //     this.actions.action.title = "Suivant"
                    //     // @ts-ignore
                    //     this.actions.action.function = () => { this.pushInvoiceDiscount() }
                    //     // @ts-ignore
                } else if (this.wizardStep !== 8 || !this.userCompany.logo) {
                    this.actions.action.display = true;
                    this.actions.action.disabled = this.nextVerification_;
                    this.actions.action.title = "Suivant";
                    this.actions.action.function = this.next;
                } else {
                    this.actions.action.display = false;
                }
            }
        }
    }

    async beforeMount() {
        await this.onMounted();
        if (this.actions && this.actions.action) {
            this.actions.action.display = true;
            this.actions.action.disabled = this.nextVerification_;
            this.actions.action.title = "Suivant";
            this.actions.action.function = this.next;
            this.actions.action.previous = this.previous;
        }
    }

    get nextVerification() {
        return this.nextVerification_();
    }

    nextVerification_() {
        if (this.wizardStep === 0) {
            return false;
        }
        if (this.wizardStep === 1) {
            return !this.checkCompany();
        }
        if (this.wizardStep === 2) {
            return !this.checkClient();
        }
        if (this.wizardStep === 3) {
            if (this.invoice.lines.length) {
                return false;
            }
            return true;
        }
        if (this.wizardStep === 6) {
            if (this.gonnaBeRecurrenceInvoice && this.invoice.startDate) {
                return false;
            }
            if (this.invoice.date && !this.gonnaBeRecurrenceInvoice) {
                return false;
            }
            return true;
        }
        if (this.wizardStep === 7) {
            if (
                this.gonnaBeRecurrenceInvoice &&
                (this.invoice.endDate || this.isInfinitReccurency)
            ) {
                return false;
            }
            if (this.invoice.date && !this.gonnaBeRecurrenceInvoice) {
                return false;
            }
            return true;
        }
        return false;
    }

    get stepTitle() {
        switch (this.wizardStep) {
            case 0:
                if (this.isQuote) {
                    return "Donnez un titre à votre devis";
                }
                if (this.isBillOfDelivery) {
                    return "Donnez un titre à votre bon de livraison";
                }
                if (this.isInvoice) {
                    return "Donnez un titre à votre facture";
                }
                break;
            case 1:
                return "Votre société";
            case 2:
                return "Choisissez votre client";
            case 3:
                return "Produits et services réalisés";
            case 4:
                return "Produits et services réalisés";
            case 5:
                return "Produits et services réalisés";
            case 6:
                return this.gonnaBeRecurrenceInvoice
                    ? "Date de la première facture"
                    : "Date d'émission";
            case 7: {
                if (this.isQuote) {
                    return "Devis valable jusqu'au " + this.formatedDueDate;
                }
                if (this.isInvoice) {
                    return this.gonnaBeRecurrenceInvoice
                        ? "Date de la dernière facture"
                        : "Date d'échéance";
                }
                // debugger;
                break;
            }
            case 8:
                if (this.isQuote || this.isInvoice) {
                    return "Mentions légales | Détail de paiement | Mode de paiement";
                }
                return "Mentions légales";
            case 9:
                return "Logo";
            case 10:
                return "Choisissez votre client";
            case 11:
                return "Périodicité";
            case 12:
                return "Delai de paiement";
            case 13:
                return "Détails du client";
            case 14:
                return "Remise";
            default:
                return `Step ${this.wizardStep}`;
        }
        return "";
    }

    disabledModification() {
        if (this.$refs && this.$refs.editCompany) {
            // @ts-ignore
            return this.$refs.editCompany.disabledModification_();
        }
        return true;
    }

    /**
     * Check if the company is subject to VAT
     */
    get isVatSubject() {
        return !isNotSubjectToVAT(this.selectedCompany.vatSystem);
    }

    get displayRegistrationTown() {
        if (this.userCompany.legalForm)
            return !["ASSO", "CL", "CNE", "FEDE", "FOND", "IND", "MUT"].includes(
                this.userCompany.legalForm,
            );
        return true;
    }

    get stepNumber() {
        switch (this.wizardStep) {
            case 0:
                return this.invoiceTableMode ? 1 : 5;
            case 1:
                return this.invoiceTableMode ? 2 : 6;
            case 2:
                return this.invoiceTableMode ? 3 : 7;
            case 3:
                return this.invoiceTableMode ? 4 : 8;
            case 4:
                return this.invoiceTableMode ? 4 : 8;
            case 5:
                return this.invoiceTableMode ? 4 : 8;
            case 6:
                return this.invoiceTableMode ? 5 : 9;
            case 7:
                return this.invoiceTableMode ? 6 : 10;
            case 8:
                return this.invoiceTableMode ? 7 : 11;
            case 9:
                return this.invoiceTableMode ? 8 : 12;
            case 10:
                return this.invoiceTableMode ? 3 : 7;
            case 11:
                return this.invoiceTableMode ? 3 : 7;
            default:
                return this.wizardStep;
        }
    }

    previous() {
        if (this.wizardStep === 0) {
            this.$emit("back");
        } else if (this.wizardStep === 5 || this.wizardStep === 6 || this.wizardStep === 14) {
            this.wizardStep = 3;
        } else if (this.wizardStep === 8) {
            if (this.isBillOfDelivery) {
                this.wizardStep = 6;
            } else {
                this.wizardStep = 7;
            }
        } else if (this.wizardStep === 10) {
            this.wizardStep = 2;
        } else if (this.wizardStep === 11) {
            this.wizardStep = 7;
        } else if (this.wizardStep === 13) {
            this.wizardStep = 10;
        } else {
            this.wizardStep--;
        }
    }

    next() {
        if (this.wizardStep === 0 && this.checkCompany()) {
            this.wizardStep = 2;
        } else if (this.wizardStep === 3) {
            this.wizardStep = 6;
        } else if (this.wizardStep === 6) {
            if (this.isBillOfDelivery) {
                this.wizardStep = 8;
            } else {
                this.wizardStep = 7;
            }
        } else if (this.wizardStep === 7 && this.gonnaBeRecurrenceInvoice) {
            this.wizardStep = 11;
        } else if (this.wizardStep === 12) {
            this.wizardStep = 8;
            // @ts-ignore
        } else if (this.wizardStep === 9 || (this.wizardStep === 8 && this.userCompany.logo)) {
            this.saveInvoice();
        } else {
            this.wizardStep++;
        }
    }

    emitModifyCompany() {
        // @ts-ignore
        this.$refs.editCompany.upsertCompany();
    }

    setClientStep() {
        this.wizardStep = 10;
    }

    addLine(newProduct = undefined) {
        const productToAdd = newProduct || this.income;
        this._addLine(productToAdd);
        if (this.wizardStep === 4) {
            this.$apollo.queries.products.refetch();
        }
        this.wizardStep = 3;
    }

    deleteLine(index) {
        this.invoice.lines.splice(index, 1);
    }

    updateClientInvoice(data: Company) {
        (this.invoice as any).client = data;
        this.wizardStep = 3;
    }

    @Watch("wizardStep")
    watcher() {
        switch (this.wizardStep) {
            case 0:
                break;
            case 1:
                if (!this.checkCompany()) {
                    this.dialogEditCompany = true;
                }
                break;
            case 2:
                break;
            case 3:
                break;
            case 4:
                break;
            case 5:
                break;
            case 6:
                break;
            case 7:
                if (this.isDateChanged) {
                    this.invoice.dueDate = moment(this.invoice.date).add(1, "M").toDate() as any;
                    // .format("YYYY-MM-DD");
                    this.isDateChanged = false;
                }
                break;
            case 8:
                break;
            case 9:
                break;
        }
    }

    companySelectedWizard(data: Company) {
        if ((data && data.address) || (data.type && data.type === "CONSUMER")) {
            this.wizardStep = 2;
            this.companySelected(data);
            return;
        }

        (this.invoice as any).client = data;
        this.wizardStep = 13;
    }

    get unitsOfTime() {
        return [
            { value: "DAYS", text: this.$t("invoice.reccurency.unitOfTime.DAYS") },
            { value: "WEEKS", text: this.$t("invoice.reccurency.unitOfTime.WEEKS") },
            { value: "MONTHS", text: this.$t("invoice.reccurency.unitOfTime.MONTHS") },
        ];
    }

    reset() {
        this.wizardStep = 0;
        this._reset();
    }

    // async pushInvoiceDiscount() {
    //     await this.addInvoiceDiscount()
    //     this.addLine()
    // }

    getSiretValue(siret: string) {
        return getSiretValue(siret);
    }

    routeToEdition() {
        this.$router.push({
            name: `${this.invoiceType}New`,
            params: { companyId: this.selectedCompany.id },
        });
        this.$store.commit("invoice/skip-wizard", true);
    }

    @Watch("invoice.date")
    resetDateChanged() {
        this.isDateChanged = true;
    }

    onInvoicePaymentDetailsChanged(data) {
        this.invoice.data.paymentDetails = data || "";
    }

    onInvoicePaymentModeChanged(data: string) {
        this.invoice.data.paymentMode = data || "";
    }
}

export default toNative(InvoiceWizard);
</script>

<style lang="scss" scoped>
.inside_card {
    background: white !important;
    padding: 2px;
    border-radius: 16px;
    border: solid 1px rgba($color: #000000, $alpha: 0.12);
}
</style>
